import { jsonFetch } from "@/lib/helpers";
import { AlarmStatistics, PaginatedAlarmList } from "@/models/alarm/alarm-list.model";
import { getAlarmListByParamsUrl, getAlarmStatisticsByParamsUrl } from "./api-url.constants";
import {
  AlarmListPaginatedDto,
  AlarmListParamsDTO,
  AlarmStatisticsDTO,
  AlarmStatisticsParamsDTO,
} from "./dtos";
import {
  mapAlarmListPaginatedDTOtoAlarmListPaginated,
  mapAlarmStatisticsDTOtoAlarmStatistics,
} from "./mappers";

export const getAlarmListByParams = async (
  params?: AlarmListParamsDTO
): Promise<PaginatedAlarmList> => {
  const alarmListDTO = await jsonFetch<AlarmListPaginatedDto>(getAlarmListByParamsUrl(params));
  return mapAlarmListPaginatedDTOtoAlarmListPaginated(alarmListDTO);
};

export const getAlarmStatisticsByParams = async (
  params?: AlarmStatisticsParamsDTO
): Promise<AlarmStatistics> => {
  const alarmStatisticsDTO = await jsonFetch<AlarmStatisticsDTO>(
    getAlarmStatisticsByParamsUrl(params)
  );
  return mapAlarmStatisticsDTOtoAlarmStatistics(alarmStatisticsDTO);
};
